import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  editHistoryModalOpen: false,
  vehicle: '',
  vehicleSN: '',
  implementSN: '',
  task: '',
  engineHours: '',
  odometer: '',
  implementHours: '',
  date: '',
  workOrder: '',
  invoice: '',
  laborCost: '',
  partsCost: '',
  laborTime: '',
  supplier: '',
  reviewedBy: '',
  notes: '',
  completedString: '',
  user: '',
  serviceEntry: {},
  serviceChecklistItemsStatus: {},
  isImplementItem: false,
  status: 'done',
};

const historyModalSlice = createSlice({
  name: 'historyModal',
  initialState,
  reducers: {
    setEditHistoryModalOpen(state, action) {
      state.editHistoryModalOpen = action.payload;
    },
    setInitialValues(state, action) {
      const entryData = action.payload;
      state.vehicle = entryData.vehicle ?? '';
      state.vehicleSN = entryData.vehicleSN ?? '';
      state.implementSN = entryData.implementSN ?? '';
      state.task = entryData.task ?? '';
      state.parentTask = entryData.parentTask;
      state.engineHours = entryData.engineHours != null && entryData.engineHours !== '' ? entryData.engineHours : '';
      state.odometer = entryData.odometer != null && entryData.odometer !== '' ? entryData.odometer : '';
      state.implementHours =
        entryData.implementHours != null && entryData.implementHours !== '' ? entryData.implementHours : '';
      state.date = entryData.dateCompleted ?? '';
      state.workOrder = entryData.workOrder ?? '';
      state.invoice = entryData.invoice ?? '';
      state.laborCost = entryData.laborCost != null && entryData.laborCost !== '' ? entryData.laborCost : '';
      state.partsCost = entryData.partsCost != null && entryData.partsCost !== '' ? entryData.partsCost : '';
      state.laborTime = entryData.laborTime != null && entryData.laborTime !== '' ? entryData.laborTime : '';
      state.supplier = entryData.supplier ?? '';
      state.reviewedBy = entryData.reviewedBy ?? '';
      state.notes = entryData.notes ?? '';
      state.completedString = entryData.completedString ?? '';
      state.user = entryData.user ?? '';
      state.serviceEntry = entryData.serviceEntry ?? {};
      state.serviceChecklistItemsStatus = entryData.serviceEntry?.service_checklist_items_status ?? {};
      state.isImplementItem = entryData.isImplementItem ?? false;
      state.status = entryData.status ?? entryData.serviceEntry?.status ?? 'done';
    },
  },
});

export const {setInitialValues, setEditHistoryModalOpen} = historyModalSlice.actions;
export default historyModalSlice.reducer;
